import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import HotRecommendations from './components/HotRecommendations';
import CategorySection from './components/CategorySection';
import LatestUpdates from './components/LatestUpdates';
import AllMangaSection from './components/AllMangaSection';
import StatsSection from './components/StatsSection';
import { siteInfo } from '@/mocks/manga';

export default function Home() {
  const pageTitle = `${siteInfo.name} | 韩漫腐韩漫耽美日漫腐国漫耽美 | 好看腐漫热门推荐大全`;
  const pageDesc = `${siteInfo.name}集结韩漫腐、韩漫耽美、日漫腐、国漫耽美等风格腐漫，精选好看腐漫与热门腐漫推荐，免费全集下拉式随心看。每日更新最新腐漫资源，打造最全腐漫阅读平台。`;

  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": pageTitle,
      "description": pageDesc,
      "url": "https://fumanhua.com",
      "isPartOf": {
        "@type": "WebSite",
        "name": siteInfo.name,
        "url": "https://fumanhua.com"
      }
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        { "@type": "ListItem", "position": 1, "name": "首页", "item": "https://fumanhua.com" }
      ]
    },
  ];

  return (
    <>
      <ScrollToTop />
      <SEOHead
        title={pageTitle}
        description={pageDesc}
        keywords="腐漫画网,韩漫腐,韩漫耽美,日漫腐,国漫耽美,好看腐漫,热门腐漫推荐,免费全集"
        canonical="https://fumanhua.com"
        jsonLd={jsonLd}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <HotRecommendations />
          <CategorySection />
          <LatestUpdates />
          <AllMangaSection />
          <StatsSection />
        </main>
        <Footer />
      </div>

      <style>{`
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes fadeInUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
        .animate-fadeIn { animation: fadeIn 1s ease-out; }
        .animate-fadeInUp { animation: fadeInUp 0.8s ease-out; }
      `}</style>
    </>
  );
}